var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Output, EventEmitter, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { StaffService } from '../../../../services/workload/staff.service';
var UserListComponent = /** @class */ (function () {
    function UserListComponent(staffService) {
        this.staffService = staffService;
        this.selectedUserChange = new EventEmitter();
        this.selected = 0;
        this.getUserSubscription = new Subscription();
        this.viewModel = {
            userList: [],
            selectedUser: 0,
            defaultValueText: 'Please Select'
        };
    }
    UserListComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.staffService.getStaff().subscribe(function (staffList) {
                                if (staffList.staff) {
                                    _this.viewModel.userList = staffList.staff;
                                    _this.setDefaultUser();
                                }
                            })];
                    case 1:
                        _a.getUserSubscription = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    UserListComponent.prototype.ngOnChanges = function () {
        this.setDefaultUser();
    };
    UserListComponent.prototype.ngOnDestroy = function () {
        this.getUserSubscription.unsubscribe();
    };
    UserListComponent.prototype.onUserChange = function () {
        var userId = parseInt(this.viewModel.selectedUser.toString());
        if (this.viewModel.selectedUser > 0) {
            this.selectedUserChange.emit(this.getUserFromList(userId));
        }
    };
    UserListComponent.prototype.setDefaultUser = function () {
        if (this.selected && this.viewModel.selectedUser >= 0) {
            this.viewModel.selectedUser = this.getUserFromList(this.selected).id;
        }
    };
    UserListComponent.prototype.getUserFromList = function (userId) {
        return this.viewModel.userList.filter(function (x) { return x.id === userId; })[0];
    };
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], UserListComponent.prototype, "selectedUserChange", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], UserListComponent.prototype, "selected", void 0);
    UserListComponent = __decorate([
        Component({
            selector: 'user-list',
            template: require('./user-list.component.html'),
            styles: [require('./user-list.component.scss')]
        }),
        __metadata("design:paramtypes", [StaffService])
    ], UserListComponent);
    return UserListComponent;
}());
export { UserListComponent };
//# sourceMappingURL=data:application/json;base64,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